function Movie({ movie, onSelectMovie }) {
return (
<li onClick={() => onSelectMovie(movie.imdbID)}>
<img src={movie.Poster} alt={`${movie.Title} poster`} /> <h3>{movie.Title}</h3> <p> <span>🗓</span> {movie.Year} </p> </li>
);
}

export default Movie;